export default __webpack_public_path__ + "static/media/img16.64ea919e.png";